import { render, staticRenderFns } from "./ProductDesignFormArtworkEdit.vue?vue&type=template&id=ac739c6a&"
import script from "./ProductDesignFormArtworkEdit.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormArtworkEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports